import { render, staticRenderFns } from "./reminders.vue?vue&type=template&id=db3e009e&scoped=true"
import script from "./reminders.vue?vue&type=script&lang=js"
export * from "./reminders.vue?vue&type=script&lang=js"
import style0 from "./reminders.vue?vue&type=style&index=0&id=db3e009e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3e009e",
  null
  
)

export default component.exports